import React from 'react';

export const Unauthorized = () => {
    return(
        <div style={{textAlign:'center'}}>
            <br></br>
            <h1>Unauthorized</h1>
        </div>
    )
}